<div class="mt-4">
  <div class="flex flex-col sm:flex-row justify-between items-stretch sm:items-center gap-4 mb-6">
    <div class="relative w-full sm:max-w-md">
      <p-iconField iconPosition="left" class="w-full">
        <p-inputIcon styleClass="pi pi-search text-slate-400" />
        <input type="text" pInputText placeholder="{{ 'clinic_procedures_search_placeholder' | translate }}"
          name="clinicProceduresSearch" autocomplete="off"
          class="w-full !bg-white !border-slate-200 !rounded-xl !text-sm focus:!ring-2 focus:!ring-primary/10 focus:!border-primary !shadow-sm transition-all"
          [(ngModel)]="searchText" (ngModelChange)="onSearch($event)" (keyup.enter)="onSearch(searchText)">
      </p-iconField>
    </div>

    <div class="flex items-center gap-2 flex-wrap">
      <button type="button" (click)="toggleExpandAll()"
        class="inline-flex items-center gap-1.5 px-3 py-2 text-[11px] font-bold uppercase tracking-wider text-slate-500 bg-white border border-slate-200 rounded-xl shadow-sm hover:bg-slate-50 hover:text-slate-700 transition-all">
        <i class="pi text-xs" [ngClass]="allExpanded ? 'pi-angle-double-up' : 'pi-angle-double-down'"></i>
        {{ (allExpanded ? 'collapse_all' : 'expand_all') | translate }}
      </button>

      <app-button *hasPermission="'Procedimentos:create'" label="{{ 'add_label' | translate }}" icon="pi pi-plus" variant="primary"
        (onClick)="showAddModal = true">
      </app-button>
    </div>
  </div>

  <div class="procedures-treetable bg-white rounded-2xl border border-slate-100 shadow-sm overflow-x-auto">
    <p-treetable [value]="filteredTreeNodes" [columns]="columns" [loading]="loading" dataKey="key"
      styleClass="prime-treetable-custom">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns; let i = index" [style.width]="col.width" [ngClass]="{
              'hidden sm:table-cell': col.field !== 'label',
              'text-right': col.field === 'base_price',
              'text-center': col.field === 'active' || col.field === 'actions'
            }">
            {{ col.header | translate }}
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
        <tr [ttRow]="rowNode" [ngClass]="{
            'leaf-row': rowNode.node.leaf,
            'group-row': !rowNode.node.leaf,
            'family-row': rowData.levelType === 'family'
          }">
          <td>
            <div class="flex items-center min-w-0">
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>

              <ng-container *ngIf="rowNode.node.leaf; else groupLabel">
                <span class="w-1.5 h-1.5 rounded-full bg-slate-300 shrink-0 mr-2.5 mt-0.5 self-start sm:self-center"></span>
                <div class="min-w-0 flex-1">
                  <span class="text-sm text-slate-700 leading-snug">{{ rowData.label }}</span>
                  <!-- Mobile-only: value + status stacked under the name -->
                  <div class="flex sm:hidden items-center flex-wrap gap-x-3 gap-y-1 mt-1.5">
                    <ng-container
                      *ngTemplateOutlet="valueTemplate; context: { $implicit: rowData.procedure }"></ng-container>
                    <ng-container
                      *ngTemplateOutlet="statusTemplate; context: { $implicit: rowData.procedure }"></ng-container>
                  </div>
                </div>
                <!-- Mobile-only: actions on the right -->
                <div class="sm:hidden shrink-0 ml-2 self-start">
                  <ng-container
                    *ngTemplateOutlet="actionsTemplate; context: { $implicit: rowData.procedure }"></ng-container>
                </div>
              </ng-container>

              <ng-template #groupLabel>
                <!-- The name and its count toggle the group too, not just the
                     chevron. A one-character hit target is the whole reason
                     users reported this: in a tree, the label IS the control. -->
                <button type="button" (click)="toggleNode(rowNode)"
                  [attr.aria-expanded]="!!rowNode.node.expanded"
                  class="group-toggle flex items-center min-w-0 text-left bg-transparent border-0 p-0 cursor-pointer">
                  <span [ngClass]="groupTextClass(rowData.levelType)">{{ rowData.label }}</span>
                  <span
                    class="inline-flex items-center justify-center min-w-[1.5rem] h-5 px-1.5 ml-2.5 text-[11px] font-extrabold text-primary bg-primary/10 rounded-full leading-none shrink-0">
                    {{ rowData.procedureCount }}
                  </span>
                </button>
              </ng-template>
            </div>
          </td>
          <td *ngFor="let col of columns.slice(1)" class="hidden sm:table-cell" [ngClass]="{
              'text-right': col.field === 'base_price',
              'text-center': col.field === 'active' || col.field === 'actions'
            }">
            <ng-container *ngIf="rowNode.node.leaf">
              <ng-container
                *ngTemplateOutlet="getTemplate(col); context: { $implicit: rowData.procedure, col: col }"></ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length" class="text-center py-16">
            <div class="flex flex-col items-center gap-3 text-slate-400">
              <i class="pi pi-inbox text-4xl opacity-40"></i>
              <span class="text-sm font-medium">{{ 'clinic_procedures_table_empty' | translate }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-treetable>
  </div>

  <ng-template #procedureTypeTemplate let-item>
    <span *ngIf="item.procedure_types_tb?.name; else noType"
      class="inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider bg-primary/10 text-primary">
      {{ item.procedure_types_tb.name }}
    </span>
    <ng-template #noType>
      <span class="text-[10px] font-bold uppercase tracking-wider text-slate-300">{{ 'clinic_procedures_table_type_none' | translate }}</span>
    </ng-template>
  </ng-template>

  <ng-template #valueTemplate let-item>
    <span class="font-bold text-slate-800 whitespace-nowrap tabular-nums">
      € {{ formatMoney(item.base_price) }}
    </span>
  </ng-template>

  <ng-template #statusTemplate let-item>
    <span
      class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-wider"
      [ngClass]="{
        'status-success': item.active === true,
        'bg-slate-100 text-slate-400 border border-slate-200': item.active !== true
      }">
      <span class="w-1.5 h-1.5 rounded-full" [ngClass]="item.active === true ? 'bg-current' : 'bg-slate-300'"></span>
      {{ (item.active === true ? 'status_active' : 'status_inactive') | translate }}
    </span>
  </ng-template>

  <ng-template #actionsTemplate let-item>
    <app-dropdown>
      <ng-template #trigger>
        <button class="p-2 text-slate-400 hover:text-primary hover:bg-primary/5 rounded-xl transition-all">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 8a2 2 0 100-4 2 2 0 000 4zM12 14a2 2 0 100-4 2 2 0 000 4zM12 20a2 2 0 100-4 2 2 0 000 4z" />
          </svg>
        </button>
      </ng-template>
      <ng-template #content>
        <div class="w-56 py-1">
          <button (click)="openDetails(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <svg class="h-4 w-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
            {{ 'action_view' | translate }}
          </button>

          <button *hasPermission="'Procedimentos:edit'" (click)="openEdit(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <svg class="h-4 w-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
            {{ 'action_edit' | translate }}
          </button>

          <button *hasPermission="'Procedimentos:edit'" (click)="toggleStatus(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <svg class="h-4 w-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1v3M4 7h16" />
            </svg>
            {{ (item.active ? 'action_deactivate' : 'action_activate') | translate }}
          </button>

          <div *hasPermission="'Procedimentos:edit'" class="h-px bg-slate-100 my-1"></div>

          <button *hasPermission="'Procedimentos:edit'" (click)="openMedicalPercentages(item)"
            class="w-full text-left px-4 py-3 text-[10px] font-black uppercase tracking-widest text-slate-600 hover:bg-slate-50 flex items-center gap-3 transition-colors">
            <svg class="h-4 w-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            {{ 'modal_medical_percentages_title' | translate }}
          </button>
        </div>
      </ng-template>
    </app-dropdown>
  </ng-template>

  <app-procedure-details-modal *ngIf="selectedProcedure" [procedure]="selectedProcedure"
    (close)="selectedProcedure = null"></app-procedure-details-modal>

  <app-add-procedure-modal *ngIf="showAddModal" [branchId]="branchId"
    (close)="onAddProcedureSuccess($event)"></app-add-procedure-modal>

  <app-edit-procedure-modal *ngIf="editingProcedure" [procedure]="editingProcedure" (close)="editingProcedure = null"
    (saved)="onEditSuccess()"></app-edit-procedure-modal>

  <app-medical-percentages-modal [isOpen]="showPercentagesModal" [procedureId]="selectedProcedureForPercentages?.id"
    [procedureName]="selectedProcedureForPercentages?.description"
    (close)="showPercentagesModal = false"></app-medical-percentages-modal>
</div>